<template>
  <v-container fluid>
   
      <v-data-table
        :headers="headers"
        :items="domains"
        :loading="tableLoading"
        :search="search"
        :items-per-page="1000"
        :sort-by="['domain']"
        :sort-desc="[true]"
        item-key="domain"
        class="elevation-1"
      >
      <template v-slot:top>
         <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        class="mx-4"
      ></v-text-field>
        </template>
       <template v-slot:item.login_url="{ item }" >

         <v-btn color="primary" @click="login(item.domain)">Login</v-btn>

        </template>

      </v-data-table>       

  <v-snackbar
      v-model="snackbar"
      :timeout="360"
      :value="true"
      color="blue"
      absolute
      center
      rounded="pill"
      top
    >
    {{ snackbarMsg }}
  </v-snackbar>

  </v-container>
</template>

<style>
canvas {
  width: 100% !important;
  height: 600px !important;
}

tbody tr:nth-child(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

</style>

<script>
export default {
  data: function() {
    return {
      domains: [],
      tableLoading: true,
      search: "",
      snackbar: false,
      snackbarMsg: "",
      headers: [
        {
          text: "Domain",
          sortable: true,
          value: "domain",
        },     
        { text: "Type", value: "type" },
  
         { text: "Login", value: "login_url" },
  
      ],
    
    };
  },

  created: function() {
  
    this.$store
      .dispatch("getDomains")
      .then(async (response) => {
          this.domains = response.data
          this.tableLoading = false
      })
    },
    methods: {
         login (domain){
                this.$store
                    .dispatch("loginDomain", {domain: domain})
                    .then(async (response) => {
                        
                        window.open(response.data, '_blank');

                    }).catch( (e) => {
                      console.log(e.response.data)
                      this.snackbarMsg = e.response.data
                      this.snackbar = true
                    })
        }

    }

  }

</script>
